
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.445.92a.695.695 0 00-.63-.42h-4.572a.686.686 0 100 1.371h2.916l-5.23 5.23a.686.686 0 00.97.97l5.23-5.23v2.916a.686.686 0 101.371 0V1.186a.685.685 0 00-.055-.265z","fill":"#7B01B5"}}),_c('path',{attrs:{"d":"M13.986 7.814a.695.695 0 00-.686.686v3.657a2.98 2.98 0 01-2.971 2.972H4.843a2.98 2.98 0 01-2.972-2.972V6.671A2.98 2.98 0 014.843 3.7H8.5a.686.686 0 100-1.371H4.843A4.343 4.343 0 00.5 6.67v5.486A4.343 4.343 0 004.843 16.5h5.486a4.343 4.343 0 004.342-4.343V8.5a.695.695 0 00-.685-.686z","fill":"#7B01B5"}})])
          )
        }
      }
    